import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { appProductBuyPopup } from "./appproduct-buypopup.component";






export function showBuyingProcessModal(modalService: NgbModal, mobileMode: string = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = appProductBuyPopup;// mobile? MobileDisconnectionInfoModalComponent: ScannerTrialPopup;
    const windowClass = "dark-modal middleWindow" + (mobile? ' mobile': '');
    let m: NgbModalRef = modalService.open(component, {
        backdrop: "static",
        size: "lg",
        centered: true,
        windowClass: windowClass
    });
    let modal = (<appProductBuyPopup>m.componentInstance);
    return modal;
}
